module.exports = __webpack_public_path__ + "img/2273.4888fa5a.gif";